
<template>
  <div>
    <v-row class="mb-3 px-3" v-if="all_categories && total_by_cat">
      <v-col cols='12' md='5' class="pt-10" >
        <v-row>
          <v-col cols='6'>
            <div>Categoria</div>
          </v-col>
          <v-col cols='2'>
            <div>Valor</div>
          </v-col>
          <v-col cols='2'>
            <div>Limite</div>
          </v-col>
          <v-col cols='2'>
            <div>Dif.</div>
          </v-col>
        </v-row>
        <v-row align="center" v-for="(cat,idx) in total_by_cat" :key="cat.id" class="px-3 py-1" style="border-bottom: solid #ccc 1px;" >
          <v-col cols='6' :class="['pa-0 font-weight-bold', cat.kind =='I'? 'error--text':'success--text']">
            {{cat.code}}- {{cat.name.split('COMPLEMENTAR - ').pop()}}:
          </v-col>
          <v-col cols='2' :class="['pa-0 font-weight-bold', idx<total_by_cat.length-1&&idx>0? 'primary--text' : cat.kind =='I'? 'error--text':'success--text']">
            <div class="text-center">{{Math.round(cat.percent)}}%</div>
          </v-col>
          <v-col cols='2' :class="['pa-0 font-weight-bold', idx<total_by_cat.length-1&&idx>0? 'primary--text' : cat.kind =='I'? 'error--text':'success--text']">
            <div class="text-center">{{Math.round(all_categories.find(c=> c.id == cat.id).percent_ref)}}%</div>
          </v-col>
          <v-col cols='2' :class="['pa-0 font-weight-bold', idx<total_by_cat.length-1&&idx>0? 'primary--text' : cat.kind =='I'? 'error--text':'success--text']">
            <div class="text-center">{{Math.round(cat.percent - all_categories.find(c=> c.id == cat.id).percent_ref) }}%</div>
          </v-col>
        </v-row>
      </v-col>
      <v-col xs='12' md='7'>
        <GChart
        v-if="chart_ready"
          type="ColumnChart"
          :data="chartData"
          :options="chartOptions"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
import Api from '@/api'

export default {
  name: 'ConsolidationsIndicators',
  props: {
    total_by_cat: {
      type: Array,
    },
  },
  components: {
    GChart
  },
  data() {
    return {
      key: null,
      all_categories: null,
      chart_ready: false,
      chartData: [
        ['', 'Improdutivo', { role: 'annotation'}, 'Complementar', { role: 'annotation'}, 'Produtivo', { role: 'annotation'}],
        // ['', 35, '35%', 30, '30%', 35, '35%'],
        // ['', 40, '40%', 0, null, 60, '60%']
      ],
      chartOptions: {
        alwaysOutside: true,
        height: 350,
        isStacked: true,
        colors: ['#ff5252', '#1976d2', '#4caf50'],
        legend: {position: 'bottom'},
        vAxis: {
          ticks: [0,10,20,30,40,50,60,70,80,90,100]
        }

      }
    }
  },
  methods: {
    getCategories() {
      Api.Category.index({with_deleted: 1}).then(r=>r.data).then(d=>{
        this.all_categories = [...d]
        this.prepareChart()
      })
    },
    prepareChart(){
      setTimeout(() => {
        this.countWithComplement()
        this.countProd()
      }, 300);
      setTimeout(() => {
        this.chart_ready = true
      }, 500);
    },
    countWithComplement(){
      let ordered = this.total_by_cat.sort((a,b)=> a.code - b.code)
      let not_prod = Math.round(ordered[0].percent)
      let prod = Math.round(ordered.slice(ordered.length-1).reduce((acc, one)=> acc + Number(one.percent), 0))
      let comp = Math.round(ordered.slice(1, ordered.length-1).reduce((acc, one)=> acc + Number(one.percent), 0))
      this.chartData.push(['',not_prod, `${not_prod}%`, comp, `${comp}%`, prod, `${prod}%`])
    },
    countProd(){
      // A soma que aparece atualmente no gráfico da cor verde, na 2a coluna (atualmente 48%) deve ser a soma dos seguinte itens:
      // (item 10 - 22% + o menor dos valores entre os dados das colunas “Valor” e “Ref” dos itens “verdes” 2, 4 e 8), respectivamente, no
      // exemplo abaixo (22% + 5% + 3% + 2% = 32%) e não os 48% que aparece atualmente.
      let not_prod = this.total_by_cat.filter(c=>c.kind == 'I').reduce((acc, one)=> acc + Number(one.percent), 0)
      
      let prod_values = []
      const ordered = this.total_by_cat.sort((a,b)=> a.code - b.code)
      const full_prod = Math.round(ordered.slice(-1).reduce((acc, one)=> acc + Number(one.percent), 0)) // 10
      const other_prod = ordered.slice(1, ordered.length-1).filter(c=>c.kind == 'P') // prod de 2 a 9
      prod_values.push(full_prod)

      other_prod.forEach(other => {
        const cat = this.all_categories.find(cat=> cat.code == other.code)
        let arr = [Number(other.percent), Number(cat.percent_ref)]
        const value = Math.round(Math.min.apply(Math, arr))
        prod_values.push(value)
      });
      let prod_total = prod_values.reduce((acc, one)=> acc + Number(one), 0)

      not_prod = Math.round(100 - prod_total)
      // not_prod = 100 - prod_total
      this.chartData.push(['',not_prod, `${not_prod}%`, null, null, prod_total, `${prod_total}%`])
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.getCategories();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>